// extracted by mini-css-extract-plugin
module.exports = {"dropZone":"DropZone_dropZone__9IN65","body":"DropZone_body__3MGN8","active":"DropZone_active__2JPXH","title":"DropZone_title__XzR4X","btnIcon":"DropZone_btnIcon__27elb"};